import React from "react";

const helpdesk = () => {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
      <h1>Help Desk</h1>
    </div>
  );
};

export default helpdesk;
